import { logOut_16 as logOut16 } from "@trustpilot/icons";
import { Text, useTranslations } from "ilenia";
import React from "react";
import { useHistory } from "react-router-dom";

import { logout } from "../../../utils/logout";
import { StyledLink, StyledLinkButton, StyledList, StyledListItem } from "../styled";
import { getUserInitials } from "./getUserInitials";
import { StyledProfile, StyledTypography, StyledAvatar, StyledLogOutContainer, StyledIcon } from "./styled";
import * as Types from "./types";

const UserSettingsDropdown: React.FC<Types.UserSettingsDropdown> = ({
  toggle,
  businessUser,
  useSimplifiedLayout,
  hasAppError,
  canViewBillingIngformation,
}) => {
  const [translations] = useTranslations();
  const history = useHistory();

  const onClick = React.useCallback(() => {
    logout();
  }, []);

  const onLinkClick = (e) => {
    e.preventDefault();
    const url = new URL(e.target.href);

    if (hasAppError) {
      window.location.href = url.pathname;
    } else {
      history.push(url.pathname);
    }
  };

  return (
    <div id="account-settings">
      {businessUser && (
        <StyledProfile aria-label={translations["BusinessUserSettings.userInfo"]}>
          <StyledAvatar aria-hidden>{getUserInitials(businessUser?.name)}</StyledAvatar>
          <StyledTypography fontSize={16} marginBottom={12} weight="heavy" data-testid="businessUserName">
            {businessUser.name}
          </StyledTypography>
          <StyledTypography fontSize={12} weight="heavy">
            {businessUser.email}
          </StyledTypography>
        </StyledProfile>
      )}
      <StyledList aria-label={translations["BusinessUserSettings.accountInfo"]}>
        {!useSimplifiedLayout && (
          <>
            {canViewBillingIngformation && (
              <StyledListItem onClick={toggle}>
                <StyledLink href="/plans-and-billing" onClick={onLinkClick}>
                  <Text id="BusinessUserSettings.plansAndBilling" />
                </StyledLink>
              </StyledListItem>
            )}
            <StyledListItem onClick={toggle}>
              <StyledLink href="/settings" onClick={onLinkClick}>
                <Text id="BusinessUserSettings.settingsOverview" />
              </StyledLink>
            </StyledListItem>
          </>
        )}
      </StyledList>
      <StyledLogOutContainer onClick={onClick}>
        <StyledLinkButton data-testid="logout" className="logout-link">
          <Text id="BusinessUserSettings.logout" />
          <div aria-hidden>
            <StyledIcon content={logOut16} />
          </div>
        </StyledLinkButton>
      </StyledLogOutContainer>
    </div>
  );
};

export default UserSettingsDropdown;
